import { useContext } from "react"
import ScheduleComponentContext from "./ScheduleComponentContext";

const useScheduleComponentContext = () => {
    return useContext(ScheduleComponentContext);
}

export default useScheduleComponentContext;